import type { Habit } from '../../shared/api';
import { addDays, startOfWeek, type DayKey } from '../../shared/days';
import { dayState, firstDay } from '../../shared/schedule';
import { formatShortDay } from '../lib/format';

/** The last `weeks` weeks: one column per week (Monday on top), one square per day. */
export function Heatmap({ habit, days, today, weeks }: { habit: Habit; days: ReadonlySet<DayKey>; today: DayKey; weeks: number }) {
  const from = addDays(startOfWeek(today), -(weeks - 1) * 7);
  const start = firstDay(habit, days);
  let count = 0;
  const cells = Array.from({ length: weeks * 7 }, (_, i) => {
    const day = addDays(from, i);
    const state = dayState(habit, days, day, today, start);
    if (state === 'done') count++;
    return { day, state };
  });
  return (
    <div
      className={`heat hc-${habit.color}`}
      style={{ gridTemplateColumns: `repeat(${weeks}, 1fr)` }}
      role="img"
      aria-label={`Letzte ${weeks} Wochen: ${count}× erledigt`}
    >
      {cells.map(({ day, state }) => (
        <span key={day} className={`heat__cell heat__cell--${state}`} title={state === 'future' ? undefined : formatShortDay(day)} />
      ))}
    </div>
  );
}
